import styled from 'styled-components';
import {scrollbar, mobileMedia, dFlex} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div<{$isEmpty?: boolean}>`
    height: 100%;
    width: 100%;
    ${dFlex};
    flex-direction: column;
    min-height: 0;
    ${({$isEmpty}) => $isEmpty ? `
        border-radius: 0;
        border: none;
        overflow: visible;
        background: transparent;
    ` : `
        height: calc(100% - var(--space-xl));
        margin-bottom: var(--space-xl);
        border-radius: var(--radius-xl);
        border: 1px solid var(--TA-color-border-subtle);
        overflow: hidden;
        background: var(--TA-color-bg-base);
    `}
    ${mobileMedia} {
        height: 100%;
        margin-bottom: 0;
        border-radius: 0;
        border: none;
        overflow: visible;
        margin-top: -30px;
    }
`;

export const contentArea = styled.div`
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    ${scrollbar}
    ${mobileMedia} {
        padding: 0 0 var(--space-3xl);
        overflow-y: auto;
    }
`;

export const dragOverlayCard = styled.div<{$isActive?: boolean}>`
    box-shadow: 0 8px 24px rgba(0,0,0,0.18);
    border-radius: var(--radius-xs);
    opacity: ${({$isActive}) => $isActive ? 0.95 : 1};
`;
